angular.module('bmsApp.crm.enquiry')
	.factory('EnquiryStatusSvc', [
		'CRUDSvc',
		function (CRUDSvc) {

			return {
				options: function (params) {
					return CRUDSvc.get('api/enquiryStatus/options', params);
				}
			};

		}
	]);
